export default {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.user(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          this.data = this.$utils.conv(resp.data,{'appSystem':'appSystem'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="查看用户" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="所属系统" content={data.appSystemText} />
          <sl-detail-list-item title="用户名" content={data.appSystemText} />
          <sl-detail-list-item title="手机号" content={data.appSystemText} />
          <sl-detail-list-item title="登录名" content={data.appSystemText} />
          
          <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}